import React from "react"

import NoApprenticeShipFees from "../../../assets/no_appren_fees-01.svg"
import ApprenBoost from "../../../assets/Appren_Boost.svg"
import NoATNZfees from "../../../assets/No_ATNZ_appren_fees.svg"
import NoHiddenCost from "../../../assets/No_hidden_cost.svg"
import PrepareStaff from "../../../assets/preparing-staff-white.svg"
import TheBestSupport from "../../../assets/The_best_support.svg"
import WeDoAdmin from "../../../assets/admin-white.svg"
import NoLoan from '../../../assets/apprentice_nostudentloan1.svg'
import NoLoan2 from '../../../assets/apprentice_nostudentloan2.svg'
import WePay from '../../../assets/apprentice_wepayyou.svg'
import WrapAround from '../../../assets/apprentice_wraparoundsupport1.svg'
import WrapAround2 from '../../../assets/apprentice_wraparoundsupport2.svg'

const Svg = ({ svg }) => {
  return (
    <>
      <div className="icon">
        {svg === "no-apprenticeship-fees" ? (
          <NoApprenticeShipFees />
        ) : svg === "apprenticeship-boost" ? (
          <ApprenBoost />
        ) : svg === "no-atnz-fees" ? (
          <NoATNZfees />
        ) : svg === "no-hidden-cost" ? (
          <NoHiddenCost />
        ) : svg === "prepare-staff" ? (
          <PrepareStaff />
        ) : svg === "the-best-support" ? (
          <TheBestSupport />
        ) : svg === "noLoan" ? (
          <NoLoan />
        ) : svg === "wePay" ? (
          <WePay />
        ) : svg === "wrapAround" ? (
          <WrapAround />
        ) : svg === "we-do-admin" ? (
          <WeDoAdmin />
        ) : (
          <div />
        )}
      </div>
    </>
  )
}

export default Svg
